import { render, staticRenderFns } from "./BaseModalForPages.vue?vue&type=template&id=1e2e02ec&scoped=true"
import script from "./BaseModalForPages.vue?vue&type=script&lang=ts"
export * from "./BaseModalForPages.vue?vue&type=script&lang=ts"
import style0 from "./BaseModalForPages.vue?vue&type=style&index=0&id=1e2e02ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2e02ec",
  null
  
)

export default component.exports